<template>
  <div class="page-container" v-if="currentNews && currentNews.title">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p class="page-date" v-if="currentNews.date">{{ currentNews.date }}</p>
    <div class="content" :class="isZh ? 'lang-zh' : 'lang-en'">
      <template v-for="(p, index) in paragraphs" :key="index">
        <!-- 文字内容 -->
        <div class="content-section">
          <div class="text-block">
            <p :class="{ 'no-indent': isNoIndentParagraph(p) }" v-html="p"></p>
          </div>
        </div>

        <!-- 在特定段落后插入图片 -->
        <div v-if="index === 1" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture1?.url">
            <p class="image-caption" v-if="currentNews.other?.picture1?.caption">{{ currentNews.other?.picture1?.caption }}</p>
          </div>
        </div>
        <div v-else-if="index === 3" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture2?.url">
            <p class="image-caption" v-if="currentNews.other?.picture2?.caption">{{ currentNews.other?.picture2?.caption }}</p>
          </div>
          <div class="image-container">
            <img :src="currentNews.other?.picture3?.url">
            <p class="image-caption" v-if="currentNews.other?.picture3?.caption">{{ currentNews.other?.picture3?.caption }}</p>
          </div>
        </div>
        <div v-else-if="index === 5" class="content-section image-section">
          <div class="image-container">
            <img :src="currentNews.other?.picture4?.url">
            <p class="image-caption" v-if="currentNews.other?.picture4?.caption">{{ currentNews.other?.picture4?.caption }}</p>
          </div>
        </div>
      </template>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useLangStore } from '../../../pinia/stores/lang';
import zhData from '../../../i18n/zh';
import enData from '../../../i18n/en';

const langStore = useLangStore();
const isZh = computed(() => langStore.currentLang.startsWith('zh'));

const currentNews = computed(() => {
  const translationData = isZh.value ? zhData : enData;
  const newsList = translationData.pages.news.company.news.list;
  return newsList.find((news: any) => news.id === 'demo4-test-completed') || {};
});

const paragraphs = computed(() => {
  const content = (currentNews.value as any)?.content || '';
  return content ? content.split('---').filter((p: string) => p.trim()) : [];
});

const isNoIndentParagraph = (text: string) => {
  const normalized = text.trimStart();
  return (
    normalized.startsWith('来源：') ||
    normalized.startsWith('Source:') ||
    normalized.startsWith('链接：') ||
    normalized.startsWith('论文链接：')
  );
};
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
  font-family: 'Microsoft YaHei', Arial, 'PingFang SC', sans-serif;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
  line-height: 1.4;
  text-align: center;
}

.page-date {
  color: #666;
  font-size: 14px;
  margin-bottom: 30px;
  text-align: right;
}

.content-section {
  margin-bottom: 20px;
}

/* 中文正文首行缩进 2 个汉字位 */
.content.lang-zh .text-block p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 2em;
}

/* 英文正文不缩进 */
.content.lang-en .text-block p {
  line-height: 1.8;
  margin-bottom: 15px;
  text-align: justify;
  text-indent: 0;
}

/* 链接段落不缩进 */
.text-block p.no-indent {
  text-indent: 0;
}

/* 链接蓝色可点击 */
.text-block :deep(a) {
  color: #1677ff;
  text-decoration: underline;
  cursor: pointer;
}

.text-block :deep(a:hover) {
  color: #0958d9;
}

.image-section {
  text-align: center;
}

.image-container {
  display: inline-block;
  margin: 10px 0;
  max-width: 800px;
}

.image-container img {
  max-width: 100%;
  border-radius: 4px;
}

.image-caption {
  font-size: 14px;
  color: #86909c;
  margin-top: 8px;
  line-height: 1.6;
}
</style>
